import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsButtonImpression,
    getGoogleAnalyticsButtonImpression
} from "./GoogleAnalyticsButtonImpression";

export interface GoogleAnalyticsLinkClick
    extends GoogleAnalyticsButtonImpression {}

const getGoogleAnalyticsNavigationClick = (
    data: EnrichedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsLinkClick => {
    return getGoogleAnalyticsButtonImpression(
        data,
        GoogleAnalyticsEvents.NavigationClick
    );
};

export { getGoogleAnalyticsNavigationClick };
